import { konstants } from '@vizeat/helpers'

const { HOST_APPLICATION_STATUSES } = konstants

export const defaultSearchStatus = 'to review,approved,re-submitted'

export const statusOptions = [
  {
    text: __('HostApplications::StatusOptions::Draft'),
    value: HOST_APPLICATION_STATUSES.DRAFT,
  },
  {
    text: __('HostApplications::StatusOptions::To review'),
    value: HOST_APPLICATION_STATUSES.TO_REVIEW,
  },
  {
    text: __('HostApplications::StatusOptions::Approved'),
    value: HOST_APPLICATION_STATUSES.APPROVED,
  },
  {
    text: __('HostApplications::StatusOptions::Rejected'),
    value: HOST_APPLICATION_STATUSES.REJECTED,
  },
  {
    text: __('HostApplications::StatusOptions::Re-submitted'),
    value: HOST_APPLICATION_STATUSES.RE_SUBMITTED,
  },
  {
    text: __('HostApplications::StatusOptions::Unsupported area'),
    value: HOST_APPLICATION_STATUSES.UNSUPPORTED_AREA,
  },
]

export const seasonsOptions = [
  {
    text: __('HostApplications::StatusOptions::Summer'),
    value: 'summer',
  },
  {
    text: __('HostApplications::StatusOptions::Spring'),
    value: 'spring',
  },
  {
    text: __('HostApplications::StatusOptions::Autumn'),
    value: 'autumn',
  },
  {
    text: __('HostApplications::StatusOptions::Winter'),
    value: 'winter',
  },
]

export const basicOptions = [
  { text: __('HostApplications::StatusOptions::All'), value: '' },
  { text: __('HostApplications::StatusOptions::Yes'), value: '1' },
  { text: __('HostApplications::StatusOptions::No'), value: '0' },
]

export const getColorFromStatus = (status) => {
  switch (status) {
    case HOST_APPLICATION_STATUSES.TO_REVIEW:
      return 'blue'
    case HOST_APPLICATION_STATUSES.REJECTED:
      return 'red'
    case HOST_APPLICATION_STATUSES.APPROVED:
      return 'green'
    case HOST_APPLICATION_STATUSES.RE_SUBMITTED:
      return 'teal'
    default:
      return 'grey'
  }
}

export const getColorFromAction = (action) => {
  switch (action) {
    case 'comment':
      return 'blue'
    case 'rejection':
      return 'red'
    case 'contact':
      return 'orange'
    case 'approval':
      return 'green'
    case 're-submission':
      return 'teal'
    case 'assignment':
      return 'violet'
    case 'rating':
      return 'yellow'
    default:
      return 'grey'
  }
}

export const culinaryLevelOrder = ['professional', 'semi-professional', 'intermediate', 'beginner']
